/**
 * Role-based redirect mapping
 * Returns the appropriate redirect path based on user role
 */
export const getRedirectPathByRole = (role) => {
  const roleMap = {
    'vendor': '/Sch/Vendor/Dashboard',
    'finance': '/Sch/Finance/Dashboard',
    'ict': '/Sch/ICT/Dashboard_ict',
    
  };

  const normalizedRole = role?.toLowerCase?.() || '';
  const path = roleMap[normalizedRole];

  if (!path) {
    console.warn(`[RoleRedirect] Unknown role: "${role}", defaulting to /`);
    return '/';
  }

  return path;
};

// Default export for convenience
export default getRedirectPathByRole;